//区分是添加单品还是修改单品
export default ({
    state: {
        sometype: 1
    },
    mutations: {
        setNow(state, type) {
            if (type == 1) {
                state.sometype = 1
            } else if (type == 2) {
                state.sometype = 2
            }
        }
    },
    actions: {
        setType(context, type) {
            context.commit('setNow', type)
        }
    }
})